// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__23Vq4","rootSmall":"AddTileButton_rootSmall__TPI5g"};